import React from 'react'

const StarHorizontalLine = () => {
  return (
    <div class="custom-star-hr"></div>
  )
}

export default StarHorizontalLine